<template>
  <div class="a-loading-primary">
    <img
      alt="loading"
      src="@/assets/loading/a-loading-primary.svg"
    />
    <p>Cargando Datos...</p>
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingPrimary',

  props: {
    svgLoading: {
      type: String,
      default: 'academy'
    }
  }
}
</script>
